import { FunctionComponent, ReactNode } from "react";
import styled from "styled-components";
import { styles } from "../styles/themes/style";
import SvgFragment from "../fragments/SvgFragment";
import { X } from "lucide-react";

interface ISidebarProps extends ISidebarStyleProps {
    sidebar?: boolean,
    children?: ReactNode,
    onClose: (e: any) => void
    $flush?: boolean
}

interface ISidebarStyleProps {
    zIndex?: number
    sidebarWidth?: number
    $flush?: boolean
}

const Sidebar: FunctionComponent<ISidebarProps> = ({ children, sidebar = true, onClose, zIndex, sidebarWidth, $flush }) => {

    return (
        <>
            {sidebar ? (
                <Container zIndex={zIndex} sidebarWidth={sidebarWidth} $flush={$flush}>
                    <CloseIcon onClick={onClose} $flush={$flush}>
                        {$flush ? <X size={16} /> : <SvgFragment type={'close'} />}
                    </CloseIcon>
                    <Content $flush={$flush}>{children}</Content>
                </Container>
            ) : (
                null
            )}
        </>
    )
}

const Container = styled.div<ISidebarStyleProps>`
    width: ${({ sidebarWidth }) => (sidebarWidth ? `${sidebarWidth}px` : '328px')};
    position: absolute;
    z-index: ${({zIndex}) => zIndex ??  '10000001'};
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: ${ ({ theme: { secondaryColor }}) => secondaryColor};
    border-radius: ${({ $flush }) => ($flush ? '0' : '8px 0 0 8px')};
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);
    padding: ${({ $flush }) => ($flush ? '0' : '24px 16px')};
    border-left: ${({ $flush }) => ($flush ? `1px solid ${styles.colors.black200}` : 'none')};
    @media (max-width: 768px) {
        width: 100%;
    }
`
const Content = styled.div<{ $flush?: boolean }>`
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: ${({ $flush }) => ($flush ? 'hidden' : 'auto')};
`
const CloseIcon = styled.div<{ $flush?: boolean }>`
    position: absolute;
    right: ${({ $flush }) => ($flush ? '16px' : '16px')};
    top: ${({ $flush }) => ($flush ? '16px' : '20px')};
    z-index: 2;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${styles.colors.black300};

    & .svg {
        height: 24px;
        width: 24px;
    }

    &:hover {
        color: ${styles.colors.black600};
        /* lucide icons are stroke based - filling them turns the icon into a solid blob */
        svg:not(.lucide) path { fill: ${styles.colors.primary400} }
    }
`

export default Sidebar
